import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { UseBaseMutationOptions } from '@/core/api/type'
import AdminAssetsService from '../../services'
import { AdminAssetsQueryKeys } from '@/modules/admin-assets/keys'
import type { AdminAssetsResponse, UpdateAdminAssetsDto } from '../../services'

export default function useMutationUpdateAdminAssets(
	props?: UseBaseMutationOptions<AdminAssetsResponse, UpdateAdminAssetsDto>,
) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationKey: [AdminAssetsQueryKeys.UPDATE_ADMIN_ASSETS],
		mutationFn: (payload: UpdateAdminAssetsDto) =>
			AdminAssetsService.updateAdminAssets(payload),
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries({
				queryKey: [AdminAssetsQueryKeys.ADMIN_ASSETS],
			})
			props?.onSuccess?.(data, variables, context)
		},
		...props,
	})
}
